import React, { useState, useEffect } from 'react';
import dynamic from 'next/dynamic';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { ListingCard } from '../../components';

import { getLatestListings } from './utils';

import css from './LatestOffersSection.module.css';


const Swiper =
  typeof window !== 'undefined'
    ? require('swiper/react').Swiper
    : dynamic(() => import('swiper/react'), {
      ssr: false,
    });
const SwiperSlide =
  typeof window !== 'undefined'
    ? require('swiper/react').SwiperSlide
    : dynamic(() => import('swiper/react'), {
      ssr: false,
    });
const Navigation =
  typeof window !== 'undefined'
    ? require('swiper').Navigation
    : dynamic(() => import('swiper'), {
      ssr: false,
    });
const Autoplay =
  typeof window !== 'undefined'
    ? require('swiper').Autoplay
    : dynamic(() => import('swiper'), {
      ssr: false,
    });

function LatestOffersSection(props) {
  const { searchedCategory, authRequired, currentUser } = props;

  const [offers, setOffers] = useState([]);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      require('swiper/css');
      require('swiper/css/bundle');
      require('swiper/css/navigation');
    }

    getLatestListings({
      pub_listingType: 'offer',
      pub_isOffer: true,
    })
      .then(resp => {
        setOffers(resp);
      })
      .catch(e => console.log(e));
  }, []);

  const screenWidth = typeof window !== 'undefined' && window.innerWidth;
  const slidesToShow = screenWidth && screenWidth < 768 ? 1.3 : 3;

  const panelMediumWidth = 50;
  const panelLargeWidth = 62.5;
  const cardRenderSizes = [
    '(max-width: 767px) 100vw',
    `(max-width: 1023px) ${panelMediumWidth}vw`,
    `(max-width: 1920px) ${panelLargeWidth / 2}vw`,
    `${panelLargeWidth / 3}vw`,
  ].join(', ');

  return offers && offers.length > 0 ? (
    <div className={css.sectionContent}>
      <h2 className={css.sectionTitle}>Products</h2>

      <Swiper
        modules={[Navigation, Autoplay]}
        navigation={{
          nextEl: '.custom_next',
          prevEl: '.custom_prev',
        }}
        spaceBetween={10}
        slidesPerView={slidesToShow}
        onSwiper={swiper => { }}
        onSlideChange={() => { }}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
      >
        <div className="custom_next">
          {' '}
          {/* we need to add our own arrows, SwiperJs doesn't show default ones  */}
          <ArrowForwardIosIcon style={{ fontSize: '40px' }} />
        </div>
        <div className="custom_prev">
          <ArrowBackIosNewIcon style={{ fontSize: '40px' }} />
        </div>
        {offers.map((o, index) => {

          return (
            <SwiperSlide key={index.toString()}>
              <ListingCard
                className={css.item}
                key={o.id.uuid}
                listing={o}
                renderSizes={cardRenderSizes}
                setActiveListing={() => { }}
                titleOnTop={true}
                isOffer
                useAuthLink={authRequired && !currentUser}
              />
            </SwiperSlide>
          );
        })}
      </Swiper>

    </div>
  ) : null;
}

export default LatestOffersSection;
